import { Button } from "@mui/material";
import { useEffect, useState } from "react";

import { lookToYaml, type ModelLook } from "../../../model/modelLook";
import { COPIED_LABEL_MS } from "../../../viewerConstants";

export function CopyYamlButton({ fileName, look }: { fileName: string; look: ModelLook }) {
  const [justCopied, setJustCopied] = useState(false);

  useEffect(() => {
    if (!justCopied) return;
    const timer = setTimeout(() => setJustCopied(false), COPIED_LABEL_MS);
    return () => clearTimeout(timer);
  }, [justCopied]);

  const copyToClipboard = () => {
    void navigator.clipboard.writeText(lookToYaml(fileName, look)).then(() => setJustCopied(true));
  };

  return (
    <Button variant="contained" fullWidth onClick={copyToClipboard} data-testid="viewer-copy-yaml">
      {justCopied ? "Copied" : "Copy settings as YAML"}
    </Button>
  );
}
